import { resolveFunnelAppConfig } from '../../funnels/appConfigs';

export default defineNuxtPlugin({
  name: 'funnel-app-config',
  enforce: 'pre',
  setup() {
    const funnel = useFunnelContext();
    const overrides = resolveFunnelAppConfig(funnel.value);

    if (Object.keys(overrides).length) {
      updateAppConfig(overrides);
    }
  },
});
